import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  Progress,
  Select,
  useColorModeValue,
  useToast
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useParams, useHistory } from "react-router-dom";
import { getToken } from "utils/auth";
import config from "config";

function AcceptInvitation() {
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("teal.300", "white");
  const bgColor = useColorModeValue("gray.800", "gray.700");

  const formColor = useColorModeValue("white", "gray.600");

  let { code } = useParams();

  const [email, setEmail] = useState("");
  const [invitationCode, setInvitationCode] = useState("");
  const [valid, setValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    password: '',
    confirm_password: '',
    description: '',
    invitation_code: '',
    email: '',
    function: ''
  });
  const [errors, setErrors] = useState({});

  const history = useHistory();

  const toast = useToast();
  useEffect(() => {
    const fetchInvitationEmail = async () => {
      try {
        const token = getToken();
        const response = await axios.get(`${config.API_URL}/invitation/getEmail/` + code);
        setEmail(response.data.email);
        setInvitationCode(code);
        if (response.data.is_registered) {
          setValid(false);
        } else {
          setValid(true);
        }
        setIsLoading(false);
      } catch (error) {
        setValid(false);
        setIsLoading(false);
        history.push("/");
      }
    };

    fetchInvitationEmail();
  }, [history]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateForm = () => {
    const newErrors = {};
    const { first_name, last_name, function: func, description, password, confirm_password } = formData;

    // Validate first name
    if (!first_name || first_name.length < 2 || first_name.length > 20 || !/^[A-Za-z]+$/.test(first_name)) {
      newErrors.first_name = "First name must be between 2 and 20 alphabetic characters.";
    }

    // Validate last name
    if (!last_name || last_name.length < 2 || last_name.length > 20 || !/^[A-Za-z]+$/.test(last_name)) {
      newErrors.last_name = "Last name must be between 2 and 20 alphabetic characters.";
    }

    // Validate function
    if (!func || func.length < 2 || func.length > 20 || !/^[A-Za-z]+$/.test(func)) {
      newErrors.function = "Function must be between 2 and 20 alphabetic characters.";
    }

    // Validate description
    if (!description || description.length < 2 || description.length > 50) {
      newErrors.description = "Description must be between 2 and 50 characters.";
    }

    // Validate password
    if (!password || password.length < 8 || password.length > 30) {
      newErrors.password = "Password must be between 8 and 30 characters.";
    }

    // Validate confirm password
    if (password !== confirm_password) {
      newErrors.confirm_password = "Passwords do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // returns true if there are no errors
  };

  const submitUseInfo = async () => {
    if (validateForm()) {
      try {
        setIsSubmitting(true);
        formData.email = email;
        formData.invitation_code = invitationCode;
        const response = await axios.post(`${config.API_URL}/invitation/accept`, formData);

        // On successful submission
      toast({
        title: "Success",
        description: "Your registration was successful!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

        history.push("/auth/signin");
      } catch (error) {

        toast({
          title: "Error",
          description: "There was an error submitting your information.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setIsSubmitting(false);
      }
    }
  };

  return (
    <Flex direction='column'  overflow='hidden' backgroundColor={bgColor}>
     
      
      <Flex direction='column' textAlign='center' justifyContent='center' align='center' mt='6.5rem' mb='30px'>
        <Text fontSize='4xl' color={textColor} fontWeight='bold'>
          Welcome! {email}
        </Text>
        <Text fontSize='md' color={textColor} fontWeight='normal' mt='10px' mb='26px'>
          You have been invited to join, please fill this form.
        </Text>
      </Flex>

      {valid ? (
        <Flex alignItems='center' justifyContent='center' >
          <Flex direction='column' w='445px' background='transparent' borderRadius='15px' p='40px' backgroundColor={formColor} boxShadow='0 20px 27px 0 rgb(0 0 0 / 5%)'>
            <Text fontSize='xl' color={textColor} fontWeight='bold' textAlign='center' mb='22px'>
              Register
            </Text>

            <FormControl isInvalid={!!errors.first_name}>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                First Name
              </FormLabel>
              <Input
                fontSize='sm'
                ms='4px'
                borderRadius='15px'
                type='text'
                placeholder='Your first name'
                mb='24px'
                size='lg'
                value={formData.first_name}
                onChange={handleInputChange}
                name='first_name'
              />
              {errors.first_name && <Text color="red.500">{errors.first_name}</Text>}
            </FormControl>

            <FormControl isInvalid={!!errors.last_name}>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Last Name
              </FormLabel>
              <Input
                fontSize='sm'
                ms='4px'
                borderRadius='15px'
                type='text'
                placeholder='Your last name'
                mb='24px'
                size='lg'
                value={formData.last_name}
                onChange={handleInputChange}
                name='last_name'
              />
              {errors.last_name && <Text color="red.500">{errors.last_name}</Text>}
            </FormControl>

            <FormControl isInvalid={!!errors.function}>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Function
              </FormLabel>
              <Select
                fontSize='sm'
                ms='4px'
                borderRadius='15px'
                placeholder='Select function'
                mb='24px'
                size='lg'
                value={formData.function}
                onChange={handleInputChange}
                name='function'
              >
                <option value='Doctor'>Doctor</option>
                <option value='Researcher'>Researcher</option>
                <option value='Student'>Student</option>
                <option value='Other'>Other</option>
              </Select>
              {errors.function && <Text color="red.500">{errors.function}</Text>}
            </FormControl>

            <FormControl isInvalid={!!errors.description}>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Description
              </FormLabel>
              <Input
                fontSize='sm'
                ms='4px'
                borderRadius='15px'
                type='text'
                placeholder='Enter a small description'
                mb='24px'
                size='lg'
                name='description'
                value={formData.description}
                onChange={handleInputChange}
              />
              {errors.description && <Text color="red.500">{errors.description}</Text>}
            </FormControl>

            <FormControl isInvalid={!!errors.password}>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Password
              </FormLabel>
              <Input
                fontSize='sm'
                ms='4px'
                borderRadius='15px'
                type='password'
                placeholder='password'
                mb='24px'
                size='lg'
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />
              {errors.password && <Text color="red.500">{errors.password}</Text>}
            </FormControl>

            <FormControl isInvalid={!!errors.confirm_password}>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Confirm Password
              </FormLabel>
              <Input
                fontSize='sm'
                ms='4px'
                borderRadius='15px'
                type='password'
                placeholder='confirm password'
                mb='24px'
                size='lg'
                name="confirm_password"
                value={formData.confirm_password}
                onChange={handleInputChange}
              />
              {errors.confirm_password && <Text color="red.500">{errors.confirm_password}</Text>}
            </FormControl>

            <Button
              type='button'
              bg='teal.300'
              fontSize='10px'
              color='white'
              fontWeight='bold'
              w='100%'
              h='45'
              mb='24px'
              onClick={submitUseInfo}
              _hover={{ bg: "teal.200" }}
              _active={{ bg: "teal.400" }}
            >
              SIGN UP
            </Button>
          </Flex>
        </Flex>
      ) : (
        <Flex alignItems='center' justifyContent='center' mb='60px' mt='20px'>
          <Flex direction='column' w='445px' background='transparent' borderRadius='15px' p='40px' mx={{ base: "100px" }} bg={bgColor} boxShadow='0 20px 27px 0 rgb(0 0 0 / 5%)'>
            <Text fontSize='xl' color={textColor} fontWeight='bold' textAlign='center' mb='22px'>
              Error
            </Text>
            <Text color={textColor} fontWeight='medium'>Invitation not valid!</Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}

export default AcceptInvitation;
